module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "d-modal transfer-rest text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Overfør positiv rest til brik")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "transfer-rest__table-scroll"
  }, [_c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "transfer-rest__check"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.users.length === 0
    },
    domProps: {
      "checked": _vm.isAllSelected
    },
    on: {
      "change": _vm.toggleAll
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    staticClass: "transfer-rest__narrow"
  }, [_vm._v("Arbejdstid")]), _vm._v(" "), _c('th', {
    staticClass: "transfer-rest__narrow"
  }, [_vm._v("Rest")])])]), _vm._v(" "), _c('tbody', [(_vm.users.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', [_vm._v("Ingen personer har positiv rest")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "transfer-rest__row",
      on: {
        "click": function($event) {
          return _vm.toggleUser(user.id)
        }
      }
    }, [_c('td', {
      staticClass: "transfer-rest__check"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isSelected(user.id)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleUser(user.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {
      staticClass: "transfer-rest__narrow"
    }, [_vm._v(_vm._s(_vm.formatHours(user.assigned_total_hours)))]), _vm._v(" "), _c('td', {
      staticClass: "transfer-rest__narrow"
    }, [_vm._v(_vm._s(_vm.formatHours(user.rest)))])])
  })], 2), _vm._v(" "), (_vm.users.length > 0) ? _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedUsers.length) + " af " + _vm._s(_vm.users.length) + " valgt")])]), _vm._v(" "), _c('td', {
    staticClass: "transfer-rest__narrow"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatHours(_vm.selectedRestSum)))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-rest__target"
  }, [_c('div', {
    staticClass: "transfer-rest__modes"
  }, [_c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--active': _vm.mode === 'new'
    },
    on: {
      "click": function($event) {
        _vm.mode = 'new'
      }
    }
  }, [_vm._v("\n            Opret ny brik\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--active': _vm.mode === 'existing'
    },
    attrs: {
      "disabled": _vm.existingBriks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.mode = 'existing'
      }
    }
  }, [_vm._v("\n            Vælg eksisterende brik\n          ")])]), _vm._v(" "), (_vm.mode === 'new') ? [_c('div', {
    staticClass: "transfer-rest__fields"
  }, [_c('div', {
    staticClass: "transfer-rest__field transfer-rest__field--wide"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Brikkens titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrik.name),
      expression: "newBrik.name"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "Eks. Rest til fordeling"
    },
    domProps: {
      "value": (_vm.newBrik.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrik, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "transfer-rest__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrik.subject_type),
      expression: "newBrik.subject_type"
    }],
    staticClass: "d-input__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newBrik, "subject_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.allowedTypes), function(t) {
    return _c('option', {
      key: t.value,
      domProps: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-rest__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Farve")]), _vm._v(" "), _c('ColorPicker', {
    attrs: {
      "initialColor": _vm.newBrik.color
    },
    on: {
      "changedColor": function($event) {
        _vm.newBrik.color = $event
      }
    }
  })], 1)] : [_c('div', {
    staticClass: "transfer-rest__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Brik")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBrikKey),
      expression: "selectedBrikKey"
    }],
    staticClass: "d-input__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBrikKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Vælg brik --")]), _vm._v(" "), _vm._l((_vm.existingBriks), function(brik) {
    return _c('option', {
      key: brik.key,
      domProps: {
        "value": brik.key
      }
    }, [_vm._v("\n                " + _vm._s(brik.name) + " (" + _vm._s(_vm.typeName(brik.subject_type)) + ")\n              ")])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "transfer-rest__hint"
  }, [_vm._v("\n              Resten lægges oven i personens nuværende timer på brikken. Personer, der ikke har brikken, får den tilføjet.\n            ")])])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        Overfør til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6718fcd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursTransferRestModal.vue
// module id = 1973
// module chunks = 1